import { render, staticRenderFns } from "./nonWorkOrderDetail.vue?vue&type=template&id=24c5d400&scoped=true&"
import script from "./nonWorkOrderDetail.vue?vue&type=script&lang=js&"
export * from "./nonWorkOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c5d400",
  null
  
)

export default component.exports